import { Box, Drawer, styled } from '@mui/material';

export const StyledBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItem: 'center',
  padding: '20px',
});

export const StyledDrawer = styled(Drawer)({
  '.new-address': {
    '.searchBox-paper': {
      width: '100% !important',
    },
    '.MuiPaper-root': {
      width: '100% !important',
    },
    '.search-box-wrapper': {
      display: 'flex',
      gap: '12px',
      alignItem: 'center',
    },
    '.close-icon': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      cursor: 'pointer',
    },
  },
});
